import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
// image
import IconError from 'assets/icons/icon-error.svg';
// style
import './inputInside.scss';

interface Props {
  id?: string,
  label?: string,
  value?: string | number,
  type?: string,
  name?: string,
  placeholder?: string,
  disabled?:boolean,
  required?:boolean,
  isValid?:boolean,
  customClass?:string,
  readOnly?:boolean,
  errorMessage?:string,
  isFocus?:boolean,
  onInputChange,
  isCustomInput?,
}

const InputInside: React.FC<Props> = (props) => {
  const {
    label, type, name, value, placeholder, disabled, required, isValid, onInputChange = () => {}, customClass,
    isCustomInput = false,
    readOnly, errorMessage, isFocus,
  } = props;

  const [inputValue, setInputValue] = useState(value);
  const refInput = useRef(null);

  const inputClasses = classNames({
    inputInside__fieldset__input: true,
    'inputInside__fieldset__input--number': type === 'number',
    'inputInside__fieldset__input--disabled': disabled,
  });

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const setValue = (e) => {
    if (isCustomInput) {
      onInputChange(e.target.value);
    } else {
      setInputValue(e.target.value);
      console.log(e.target.name, e.target.value);
      onInputChange(e.target.name, e.target.value);
    }
  };

  const handleSetCursor = () => {
    if (isFocus) {
      refInput.current.setSelectionRange(7, 7);
    }
  };

  return (
    <section className="inputInside">
      <div className="inputInside__fieldset">
        {label && (<span className="inputInside__fieldset__label">{label}</span>)}
        <div className={inputClasses}>
          <input
            className={customClass}
            type={type}
            name={name}
            value={inputValue}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            onChange={setValue}
            readOnly={readOnly}
            onClick={handleSetCursor}
            ref={refInput}
          />
          {!isValid && <img className="inputInside__fieldset__input__icon" src={IconError} alt="error" />}
        </div>
      </div>
      {!isValid && errorMessage && (
      <span className="notification notification--error">
        {errorMessage}
      </span>
      )}
    </section>
  );
};

InputInside.defaultProps = {
  label: null,
  type: 'text',
  name: '',
  value: '',
  placeholder: '',
  disabled: false,
  required: false,
  isValid: true,
  onInputChange: () => {},
  customClass: '',
  readOnly: false,
  errorMessage: null,
  isFocus: false,
};

export default InputInside;
